import React from 'react';

import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import { translate } from '../../../i18n/I18nProvider';

const ActionsButtons = ({ onCloseClick, handleSubmit, disabled, hasMoved }) => {
  return (
    <>
      <SecondaryButton onClick={onCloseClick}>
        {hasMoved ? translate('BUTTON.CLOSE') : translate('BUTTON.CANCEL')}
      </SecondaryButton>
      {!hasMoved && (
        <PrimaryButton onClick={handleSubmit} disabled={disabled}>
          {translate('MOVE')}
        </PrimaryButton>
      )}
    </>
  );
};

export default ActionsButtons;
